import './sortToggle.scss';
import React, { useState } from 'react';
import IconButton from '../iconButton/IconButton';
import { generalStore } from '../../store';

const SortToggle = () => {
    const [collectionType, setCollectionType] = useState(generalStore.getState().gridStyle);

    const onToggleCollectionType = (type) => {
        if (collectionType !== type) {
            setCollectionType(type);
            generalStore.getState().setGridStyle(type);
        }
    };

    return (
        <div className="sort">
            <IconButton
                icon={collectionType === 'list' ? 'collection-grid' : 'collection-grid-active'}
                onClick={() => onToggleCollectionType('grid')}
                size="small"
                name='grid-view-button'
            />
            <IconButton
                icon={collectionType === 'grid' ? 'collection-list' : 'collection-list-active'}
                onClick={() => onToggleCollectionType('list')}
                size="small"
                name='list-view-button'
            />
        </div>
    );
};
export default SortToggle;
